module.exports = __webpack_public_path__ + "static/media/2019-24-hn.334793c2.jpg";